'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Functions = require('../core/Functions');

var _underscore = require('../utils/underscore');

var _RootNode = require('../utils/RootNode');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'UILayer',

  propTypes: {
    children: _react.PropTypes.element.isRequired,
    onUnmount: _react.PropTypes.func,
    rootNode: _react.PropTypes.object,
    transitionProps: _react.PropTypes.object,
    unmountDelay: _react.PropTypes.number.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      unmountDelay: 0
    };
  },
  componentDidMount: function componentDidMount() {
    this.mountChildren();
  },
  componentDidUpdate: function componentDidUpdate() {
    this.updateChildren();
  },
  componentWillUnmount: function componentWillUnmount() {
    var _props = this.props,
        transitionProps = _props.transitionProps,
        unmountDelay = _props.unmountDelay;

    this.dispatchDOMEvent('uilayer-willunmount');
    this._unmounting = true;
    if (transitionProps) {
      this.updateChildren(); // render CSSTransitionGroup with null to trigger leave
    }
    if (!unmountDelay) {
      this.unmountChildren();
    } else {
      setTimeout(this.unmountChildren, unmountDelay);
    }
  },
  dispatchDOMEvent: function dispatchDOMEvent(eventName) {
    if (!this._element) {
      return;
    }

    // Note that `new Event()` does not work in IE11! (HubSpot/UIComponents#222)
    var event = document.createEvent('Event');
    event.initEvent(eventName, true, true);
    (0, _reactDom.findDOMNode)(this._element).dispatchEvent(event);
  },
  getRootNode: function getRootNode() {
    this._rootNode = this._rootNode || this.props.rootNode || (0, _RootNode.getDefaultNode)();
    return this._rootNode;
  },
  mountChildren: function mountChildren() {
    var _props2 = this.props,
        children = _props2.children,
        transitionProps = _props2.transitionProps;

    this._element = document.createElement('div');
    this._element.className = 'private-layer';
    this.getRootNode().appendChild(this._element);
    var tree = this.renderTree({ children: children, transitionProps: transitionProps });
    this._childRef = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, tree, this._element);
  },
  updateChildren: function updateChildren() {
    var _props3 = this.props,
        children = _props3.children,
        transitionProps = _props3.transitionProps;

    var tree = this.renderTree({ children: children, transitionProps: transitionProps });
    _reactDom2.default.unstable_renderSubtreeIntoContainer(this, tree, this._element);
  },
  unmountChildren: function unmountChildren() {
    var onUnmount = this.props.onUnmount;

    try {
      _reactDom2.default.unmountComponentAtNode(this._element);
    } catch (e) {
      // If an error occurs during unmount we want it to be logged, but we don't
      // want it to break the app!
      (0, _underscore.defer)(function () {
        throw e;
      });
    }
    this.getRootNode().removeChild(this._element);
    (0, _Functions.callIfPossible)(onUnmount);
  },
  renderTree: function renderTree(_ref) {
    var children = _ref.children,
        transitionProps = _ref.transitionProps;

    if (!transitionProps) {
      return children;
    }
    return _react2.default.createElement(
      _reactAddonsCssTransitionGroup2.default,
      transitionProps,
      this._unmounting ? null : children
    );
  },
  render: function render() {
    // The child is rendered to _element
    return null;
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/layer/UILayer.js
// module id = 165
// module chunks = 0